import React from 'react';
import { MyContext } from '../../App';
export function withContext(Component) {
    return function WrapperComponent(props) {
        return (
            <MyContext.Consumer>
                {state => <Component {...props} context={state} />}
            </MyContext.Consumer>
        );
    };
}